/**
 *
 * @returns get base PUBLIC_URL
 */
export const getBaseNameURL = () => {
  return process.env.PUBLIC_URL || "";
};
